export default __webpack_public_path__ + "static/media/illustration.a982529d.png";